import { render, staticRenderFns } from "./PowerChatLeftBar.vue?vue&type=template&id=b500812c&scoped=true"
import script from "./PowerChatLeftBar.vue?vue&type=script&lang=js"
export * from "./PowerChatLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b500812c",
  null
  
)

export default component.exports